import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

export const getPostModuleFeedbackQuestionsApiCall = async ({
  module,
  languageId = 1,
}) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/feedback-questions?type=${module}&languageId=${languageId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const savePostModuleFeedbackApiCall = async (args) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/module-feedback`,
      args,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
